import createClass from 'create-react-class'
import React from 'react'
import CodeMirror from 'live/components/codemirror/codemirror'
import { Panel, PanelGroup } from 'react-bootstrap'
import i18n from 'live/services/i18n'
import FormBase from 'live/components/extensions/ui/form'
import FormGroup from 'live/components/forms/ui/form-group'
import { FormCheckbox } from 'live/components/forms/ui/form-checkbox'
import ValidationMixin from 'live/components/forms/mixins/validation-mixin'
import ObjectInitializerMixinFactory from 'live/components/forms/mixins/object-initializer'

const ObjectInitializerMixin = ObjectInitializerMixinFactory('/rest/extension', {
    type: 'dvd-config',
    active: false,
    config: {
        wellCompanyKey: '',
        pipesQueryForSensorData: '',
        initialDelay: 60,
        timeBetweenSyncs: 10800,
        wellsPerPool: 5,
        timeOutPerWell: 120,
        startSyncQueue: true
    },
    fullQualifier: '',
    qualifier: '',
    status: {}
})

const Form = createClass({
    mixins: [ObjectInitializerMixin, ValidationMixin],
    validations: {
        properties: {
            config: {
                properties: {}
            }
        }
    },
    _onSuccess: function () {
        window.location.href = '#/integrations/' + this.state.object.type + '/' + this.state.object.id
    },
    _onDelete: function () {
        window.location.href = '#/integrations/'
    },
    onChangeCheckbox: function (e) {
        const object = this.state.object
        const config = object.config
        const field = e.target.name
        config[field] = !config[field]
        this.applyObj({
            config: config
        })
        this.handleValidation(e)
    },
    render: function () {
        const object = this.state.object
        const config = object.config

        return (
            <FormBase self={this}>
                <div className="form-control">
                    <PanelGroup accordion id="accordion-uncontrolled">
                        <Panel eventKey={'1'}>
                            <Panel.Heading>
                                <Panel.Title toggle>
                                    <h3>Sync Settings</h3>
                                </Panel.Title>
                                <Panel.Body>
                                    <div>
                                        <FormCheckbox
                                            name="startSyncQueue"
                                            checked={
                                                typeof config.startSyncQueue !== 'undefined'
                                                    ? config.startSyncQueue
                                                    : false
                                            }
                                            onChange={this.onChangeCheckbox}
                                            description={i18n('Start Data Sync')}
                                            disabled={undefined}
                                            note={i18n(
                                                '(If enabled, the data sync will be triggered as soon as the configuration is saved)'
                                            )}
                                        />
                                        <FormGroup
                                            type="text"
                                            label={<span> {i18n('Well Type')}</span>}
                                            name="config.wellCompanyKey"
                                            value={config.wellCompanyKey}
                                            onChange={this.handleValidation}
                                            validationState={this.validationState('config.wellCompanyKey')}
                                            hasFeedback
                                            help={i18n(
                                                'Filter wells by Well Type in a case-insensitive manner by checking if the specified input is contained in the Well->Description->Type. Common values are: "onshore", "offshore_floating" and "offshore_static'
                                            )}
                                        />
                                        <FormGroup
                                            type="text"
                                            label={<span> {i18n('Sync Start Delay (in seconds)')}</span>}
                                            name="config.initialDelay"
                                            value={config.initialDelay}
                                            onChange={this.handleValidation}
                                            validationState={this.validationState('config.initialDelay')}
                                            hasFeedback
                                            help={i18n('Time to start a sync after a configuration is added/updated')}
                                        />
                                        <FormGroup
                                            type="text"
                                            label={<span> {i18n('Time between two syncs (in seconds)')}</span>}
                                            name="config.timeBetweenSyncs"
                                            value={config.timeBetweenSyncs}
                                            onChange={this.handleValidation}
                                            validationState={this.validationState('config.timeBetweenSyncs')}
                                            hasFeedback
                                            help={i18n('Time to stay idle after the wells in a queue are processed')}
                                        />
                                        <FormGroup
                                            type="text"
                                            label={<span> {i18n('Process Concurrency')}</span>}
                                            name="config.wellsPerPool"
                                            value={config.wellsPerPool}
                                            onChange={this.handleValidation}
                                            validationState={this.validationState('config.wellsPerPool')}
                                            hasFeedback
                                            help={i18n('Number of wells to be processed in parallel')}
                                        />
                                        <FormGroup
                                            type="text"
                                            label={<span> {i18n('Timeout (in seconds)')}</span>}
                                            name="config.timeOutPerWell"
                                            value={config.timeOutPerWell}
                                            onChange={this.handleValidation}
                                            validationState={this.validationState('config.timeOutPerWell')}
                                            hasFeedback
                                            help={i18n('Maximum time that can be spent on processing 1 well')}
                                        />
                                        <div>
                                            <label>PIPES Query</label>
                                            <div>
                                                <CodeMirror
                                                    id="config.pipesQueryForSensorData"
                                                    value={config.pipesQueryForSensorData}
                                                    onChange={value =>
                                                        this.handleValidation({
                                                            target: {
                                                                value,
                                                                name: 'config.pipesQueryForSensorData'
                                                            }
                                                        })
                                                    }
                                                    options={{
                                                        mode: 'pipes',
                                                        matchBrackets: true,
                                                        lineNumbers: true,
                                                        foldGutter: true
                                                    }}
                                                />
                                            </div>
                                            <span class="help-block">
                                                PIPES query to pull the real-time sensor data. This query supports
                                                placeholders. By default, it supports '__event_type__' and
                                                '__raw_event_type__'
                                            </span>
                                        </div>
                                    </div>
                                </Panel.Body>
                            </Panel.Heading>
                        </Panel>
                    </PanelGroup>
                </div>
            </FormBase>
        )
    }
})
export default Form
